import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';

import {
  Text,
  IconCountry,
  CompanyIcon,
  CompanyStatus,
  WithTooltip
} from '../Elements';

import { cutTextforToltip } from 'utils/common';

import classes from './Company.module.scss';
import { links } from '../../../../data/constants';
import { useTranslation } from 'react-i18next';

const Company = ({
  nameCompany = 'NA',
  status,
  terminationStatus,
  terminationStatusDate,
  description,
  country,
  recordType,
  domain = '',
  industry,
  addStatus,
  customerId,
  searchText,
  isCheckpointTenant
}) => {
  const { t } = useTranslation('activity');
  const maxLettersInName = 25;

  return (
    <div className={classes.orgWrap}>
      <div className={classes.logo}>
        <CompanyIcon domain={domain} />
        {country && country !== '-' && country !== 'NA' && (
          <IconCountry className={classes.flag} country={country} size="16px" />
        )}
      </div>
      <div className={classes.info}>
        <div className={classes.company}>
          {nameCompany !== '' &&
            (nameCompany.length >= maxLettersInName ? (
              <WithTooltip text={nameCompany}>
                <div>
                  <Text className={classes.company_name} weight="b">
                    <Highlighter
                      autoEscape
                      highlightClassName={classes.highlight}
                      searchWords={[searchText]}
                      textToHighlight={cutTextforToltip(
                        nameCompany,
                        maxLettersInName - 3
                      )}
                    />
                  </Text>
                </div>
              </WithTooltip>
            ) : (
              <Text className={classes.company_name} weight="b">
                <Highlighter
                  autoEscape
                  highlightClassName={classes.highlight}
                  searchWords={[searchText]}
                  textToHighlight={cutTextforToltip(
                    nameCompany,
                    maxLettersInName - 3
                  )}
                />
              </Text>
            ))}

          {status && status !== '-' && status !== 'NA' && (
            <CompanyStatus
              status={status}
              terminationStatus={terminationStatus}
              terminationStatusDate={terminationStatusDate}
              addStatus={addStatus}
            />
          )}

          {isCheckpointTenant && (
            <WithTooltip text={t('tenantsAssociation.ASSOCIATED')}>
              <img
                width={16}
                height={16}
                src={`${links.imagesBaseUrl}/icons2/icon_checkPoint.svg`}
                alt="checkpoint tenant indicator"
                className={classes.checkpointIndicator}
              />
            </WithTooltip>
          )}
        </div>
        {description && (
          <Text type={'p'} className={classes.description} weight="b">
            <Text className={classes.description_text} size={0}>
              <Highlighter
                autoEscape
                highlightClassName={classes.highlight}
                searchWords={[searchText]}
                textToHighlight={customerId}
              />
            </Text>
            <Text className={classes.description_type}>{description}</Text>
            {recordType && recordType !== '-' && recordType !== 'NA' && (
              <Text className={classes.description_type}>{recordType}</Text>
            )}
          </Text>
        )}
        {industry && industry !== '-' && industry !== 'NA' && (
          <Text className={classes.description_text} size={0}>
            {industry}
          </Text>
        )}
      </div>
    </div>
  );
};

Company.propTypes = {
  nameCompany: PropTypes.string,
  status: PropTypes.string,
  terminationStatus: PropTypes.string,
  terminationStatusDate: PropTypes.string,
  description: PropTypes.string,
  country: PropTypes.string,
  recordType: PropTypes.string,
  domain: PropTypes.string,
  industry: PropTypes.string,
  addStatus: PropTypes.string,
  customerId: PropTypes.string,
  searchText: PropTypes.string,
  isCheckpointTenant: PropTypes.bool
};

export default Company;
